module.exports = __webpack_public_path__ + "static/media/rewarding-fair-players.a3e9f633.png";